import { makeSelectFieldOptionsFromEnum } from '../FormHelper';

//enums
export const dayEnum = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export const amPmEnum = {
  AM: 'AM',
  PM: 'PM',
};

//options
export const dayOptions = makeSelectFieldOptionsFromEnum(dayEnum);
export const amPmOptions = makeSelectFieldOptionsFromEnum(amPmEnum);

export const hourOptions = [
  { key: 1, text: '01', value: 1 },
  { key: 2, text: '02', value: 2 },
  { key: 3, text: '03', value: 3 },
  { key: 4, text: '04', value: 4 },
  { key: 5, text: '05', value: 5 },
  { key: 6, text: '06', value: 6 },
  { key: 7, text: '07', value: 7 },
  { key: 8, text: '08', value: 8 },
  { key: 9, text: '09', value: 9 },
  { key: 10, text: '10', value: 10 },
  { key: 11, text: '11', value: 11 },
  { key: 12, text: '12', value: 0 },
];

//methods
export const makeMinuteOptions = (interval = 15) => {
  if (interval <= 0) {
    interval = 1;
  }

  const ret = [];

  for (let i = 0; i < 60; i += interval) {
    const text = `${i < 10 ? '0' : ''}${i}`;
    ret.push({ key: i, text, value: i });
  }

  return ret;
};

export const getDays = (schedule) =>
  Object.values(dayEnum).reduce((ret, value) => {
    if (schedule.charAt(value) === 'Y') {
      return [...ret, value];
    }

    return ret;
  }, []);

export const get24Hours = (schedule) => parseInt(schedule.substr(7, 2), 10);
export const getHours = (schedule) => get24Hours(schedule) % 12;
export const getMinutes = (schedule) => parseInt(schedule.substr(9, 2), 10);
export const getAmPm = (schedule) =>
  get24Hours(schedule) >= 12 ? amPmEnum.PM : amPmEnum.AM;

export const setDays = (schedule, days) => {
  const scheduleDays = Array(7).fill('N');

  for (let i = 0; i < days.length; i++) {
    scheduleDays[days[i]] = 'Y';
  }

  //update schedule
  const newSchedule = schedule.split('');
  newSchedule.splice(0, 7, ...scheduleDays);
  const ret = newSchedule.join('');

  return ret;
};

export const setHours = (schedule, hours, amPm = amPmEnum.AM) => {
  const offset = amPm === amPmEnum.PM ? 12 : 0;
  const scheduleHours = String(hours + offset).split('');

  if (scheduleHours.length < 2) {
    scheduleHours.unshift('0');
  }

  //update schedule
  const newSchedule = schedule.split('');
  newSchedule.splice(7, 2, ...scheduleHours);
  const ret = newSchedule.join('');

  return ret;
};

export const setMinutes = (schedule, minutes) => {
  const scheduleMinutes = String(minutes).split('');

  if (scheduleMinutes.length < 2) {
    scheduleMinutes.unshift('0');
  }

  //update schedule
  const newSchedule = schedule.split('');
  newSchedule.splice(9, 2, ...scheduleMinutes);
  const ret = newSchedule.join('');

  return ret;
};

export const setAmPm = (schedule, amPm) => {
  let curHours = get24Hours(schedule);

  if (amPm === amPmEnum.AM) {
    if (curHours < 12) {
      return schedule;
    }

    curHours -= 12;
  } else {
    if (curHours >= 12) {
      return schedule;
    }

    curHours += 12;
  }

  const scheduleHours = String(curHours).split('');

  if (scheduleHours.length < 2) {
    scheduleHours.unshift('0');
  }

  //update schedule
  const newSchedule = schedule.split('');
  newSchedule.splice(7, 2, ...scheduleHours);
  const ret = newSchedule.join('');

  return ret;
};



// WEBPACK FOOTER //
// ./src/common/Helpers/ScheduleHelpers.js